import { Box, Typography, useTheme, useMediaQuery, Grid, IconButton, Button, LinearProgress } from "@mui/material";
import { TEXT_LIGHT_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors";
import { MainGroupModel } from "../../models/mainGroup";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import useMainGroupController from "./controller/MainGroup";
import { DivisionModel } from "../../models/division";
import { FormDivision } from "./FormDivision";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../../components/ConfirmDialog";
import { CategoryModel } from "../../models/category";
import FormCategory from "./FormCategoy";
import { SubCategoryModel } from "../../models/subCategory";
import FormSubCategory from "./FormSubCategory";
import ViewDataForm from "./ViewDataForm";
import { IMAGE_CATEGORY_ROOT_URL } from "../../constants/imageUrl";
interface Props {
    mainGroupData: MainGroupModel,
    onClose: VoidFunction,
    merchantId: string;
}

const MainGroup = ({ mainGroupData, onClose, merchantId }: Props) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation("global");

    const controller = useMainGroupController({
        mainGroupId: mainGroupData?.id,
        masterMainGroupId: mainGroupData?.supplies_main_group_name?.id
    });

    return <Box>
        {
            !controller?.loading
                ?
                <>
                    <IconButton onClick={onClose}>
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                    {t("category_page.Code")} : <span>{mainGroupData?.supplies_main_group_name?.code}</span>
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={isSmallScreen ? 1 : 2} mt={1}>
                            <Grid item xs={12} sm={6} md={3} sx={{ width: '100%' }}>
                                <Box p={isSmallScreen ? 1 : 2} sx={{
                                    background: '#f5fcff', borderRadius: '15px', boxShadow:
                                        '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)'
                                    , height: isSmallScreen ? "auto" : '70vh',
                                    overflow: 'auto'
                                }}>
                                    <Typography variant="h5" mb={1} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                        Main Group
                                    </Typography>
                                    <Box sx={{
                                        p: 2, borderRadius: '5px', display: 'flex', alignItems: 'center', background: '#ECF8FE', boxShadow:
                                            '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                    }}>
                                        <Box>
                                            <Box>
                                                <img src={IMAGE_CATEGORY_ROOT_URL + mainGroupData?.supplies_main_group_name?.icon?.url} alt='' style={{ width: '30px', height: '30px' }} />
                                            </Box>
                                            <Typography sx={{ fontSize: 12 }} color={TEXT_TITLE_COLOR}>
                                                {t("category_page.English name")}: <span>{mainGroupData?.supplies_main_group_name?.main_group_name_la}</span>
                                            </Typography>
                                            <Typography sx={{ fontSize: 12 }} color={TEXT_TITLE_COLOR}>
                                                {t("category_page.Lao name")}: <span>{mainGroupData?.supplies_main_group_name?.main_group_name_en}</span>
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} sx={{ width: '100%' }}>
                                <Box p={isSmallScreen ? 1 : 2} sx={{
                                    background: '#f5fcff', borderRadius: '15px', boxShadow:
                                        '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)'
                                    , height: isSmallScreen ? "auto" : '70vh',
                                    overflow: 'auto'
                                }}>
                                    <Typography variant="h5" sx={{ mb: 1 }} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                        Division
                                    </Typography>
                                    {controller?.dataDivision?.map((item: DivisionModel, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                width: 'auto',
                                                backgroundColor: controller.selectedDivision === item ? '#C8FACD' : '#ECF8FE',
                                                borderRadius: '10px',
                                                boxShadow:
                                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                mb: 1, p: 1
                                            }}
                                        >
                                            <Button sx={{ textTransform: 'none', color: 'black', width: '100%', justifyContent: 'flex-start', textAlign: 'left' }} onClick={() => controller.handleSelectDivision(item)}>
                                                <Box>
                                                    <Box>
                                                        <img src={IMAGE_CATEGORY_ROOT_URL + item?.supplies_division_name?.icon?.url} alt="" style={{ width: '30px', height: '30px' }} />
                                                    </Box>
                                                    <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("category_page.English name")}: <span>{item?.supplies_division_name?.division_name_en}</span></Typography>
                                                    <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("category_page.Lao name")}: <span>{item?.supplies_division_name?.division_name_la}</span></Typography>

                                                    {/* <Box>
                                                        <span>{index + 1} . Code : </span>
                                                        {item?.supplies_division_name?.code}
                                                    </Box> */}
                                                </Box>
                                            </Button>
                                            {/* <Box sx={{ width: '30%', display: 'flex' }}>
                                                <IconButton onClick={() => controller.handleOpenDataFormView({
                                                    title: "Division",
                                                    code: item?.supplies_division_name?.code,
                                                    nameEn: item?.supplies_division_name?.division_name_en,
                                                    nameLa: item?.supplies_division_name?.division_name_la,
                                                    imageUrl: IMAGE_CATEGORY_ROOT_URL + item?.supplies_division_name?.icon?.url
                                                })}>
                                                    <RemoveRedEyeIcon />
                                                </IconButton>
                                                <IconButton onClick={() => controller.handleOpenDeleteDivision(item?.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Box> */}
                                        </Box>
                                    ))}
                                    <Box mt={1} ml={isSmallScreen ? -0.5 : -1}>
                                        {/* <Button onClick={controller.handleOpenFormDivision} sx={{ textTransform: 'none', color: TEXT_TITLE_COLOR }}>
                                            Add more
                                            &nbsp;
                                            <AddIcon sx={{ width: 15, height: 15 }} />
                                        </Button> */}
                                    </Box>
                                </Box>
                            </Grid>
                            {
                                controller.selectedDivision
                                &&
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    {
                                        controller.loadingGetCategory ? <LinearProgress /> :
                                            <Box p={isSmallScreen ? 1 : 2} sx={{
                                                background: '#f5fcff', borderRadius: '15px', boxShadow:
                                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)'
                                                , height: isSmallScreen ? "auto" : '70vh',
                                                overflow: 'auto'
                                            }}>
                                                <Typography variant="h5" sx={{ mb: 1 }} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                                    Category
                                                </Typography>

                                                {controller?.dataCategory?.map((item: CategoryModel, index: number) => (
                                                    <Box
                                                        key={item?.id}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            width: 'auto',
                                                            backgroundColor: controller.selectedCategory === item ? '#C8FACD' : '#ECF8FE',
                                                            borderRadius: '10px',
                                                            boxShadow:
                                                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                            mb: 1, p: 1
                                                        }}
                                                    >
                                                        <Button sx={{ textTransform: 'none', color: 'black', width: '100%', justifyContent: 'flex-start', textAlign: 'left' }} onClick={() => controller.handleSelectCategory(item)}>
                                                            <Box>
                                                                <Box>
                                                                    <img src={IMAGE_CATEGORY_ROOT_URL + item?.supplies_product_category?.icon?.url} alt="" style={{ width: '30px', height: '30px' }} />
                                                                </Box>
                                                                <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("category_page.English name")}: <span>{item?.supplies_product_category?.category_name_en}</span></Typography>
                                                                <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("category_page.Lao name")}: <span>{item?.supplies_product_category?.category_name_la}</span></Typography>

                                                                {/* <span>{index + 1}. Code : </span>
                                                                {item?.supplies_product_category?.code} */}
                                                            </Box>
                                                        </Button>
                                                        {/* <Box sx={{ width: '30%', display: 'flex' }}>
                                                            <IconButton onClick={() => controller.handleOpenDataFormView({
                                                                title: "Category",
                                                                code: item?.supplies_product_category?.code,
                                                                nameEn: item?.supplies_product_category?.category_name_en,
                                                                nameLa: item?.supplies_product_category?.category_name_la,
                                                                imageUrl: IMAGE_CATEGORY_ROOT_URL + item?.supplies_product_category?.icon?.url
                                                            })}>
                                                                <RemoveRedEyeIcon />
                                                            </IconButton>
                                                            <IconButton onClick={() => controller.handleOpenDeleteCategoryDialog(item?.id)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Box> */}
                                                    </Box>
                                                ))}
                                                <Box mt={1} ml={isSmallScreen ? -0.5 : -1}>
                                                    {/* <Button onClick={controller.handleOpenCategoryForm} sx={{ textTransform: 'none', color: TEXT_LIGHT_COLOR }}>
                                                        Add more
                                                        &nbsp;
                                                        <AddIcon sx={{ width: 15, height: 15 }} />
                                                    </Button> */}
                                                </Box>

                                            </Box>
                                    }

                                </Grid>
                            }
                            {
                                controller.selectedCategory
                                &&
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    {
                                        controller.loadingGetSubCategory ? <LinearProgress /> :
                                            <Box p={isSmallScreen ? 1 : 2} sx={{
                                                background: '#f5fcff', borderRadius: '15px', boxShadow:
                                                    '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)'
                                                , height: isSmallScreen ? "auto" : '70vh',
                                                overflow: 'auto'
                                            }}>
                                                <Typography variant="h5" sx={{ mb: 1 }} color={TEXT_TITLE_COLOR} fontWeight='bold'>
                                                    Sub Category
                                                </Typography>

                                                {controller?.dataSubCategory?.map((item: SubCategoryModel, index: number) => (
                                                    <Box
                                                        key={item?.id}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            width: 'auto',
                                                            backgroundColor: '#ECF8FE',
                                                            borderRadius: '10px',
                                                            boxShadow:
                                                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                                            mb: 1, p: 1
                                                        }}
                                                    >
                                                        <Button sx={{ textTransform: 'none', color: 'black', width: '100%', justifyContent: 'flex-start', textAlign: 'left' }} onClick={() => { }}>
                                                            <Box>
                                                                <Box>
                                                                    <img src={IMAGE_CATEGORY_ROOT_URL + item?.supplies_product_sub_category?.icon?.url} alt="" style={{ width: '30px', height: '30px' }} />
                                                                </Box>
                                                                <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("category_page.English name")}: <span>{item?.supplies_product_sub_category?.sub_category_name_en}</span></Typography>
                                                                <Typography sx={{ fontSize: 12 }} color={TEXT_LIGHT_COLOR}>{t("category_page.Lao name")}: <span>{item?.supplies_product_sub_category?.sub_category_name_la}</span></Typography>
                                                                {/* <span>{index + 1}. Code : </span>
                                                                {item?.supplies_product_sub_category?.code} */}
                                                            </Box>
                                                        </Button>
                                                        {/* <Box sx={{ width: '30%', display: 'flex' }}>
                                                            <IconButton onClick={() => controller.handleOpenDataFormView({
                                                                title: "Sub Category",
                                                                code: item?.supplies_product_sub_category?.code,
                                                                nameEn: item?.supplies_product_sub_category?.sub_category_name_en,
                                                                nameLa: item?.supplies_product_sub_category?.sub_category_name_la,
                                                                imageUrl: IMAGE_CATEGORY_ROOT_URL + item?.supplies_product_sub_category?.icon?.url
                                                            })}>
                                                                <RemoveRedEyeIcon />
                                                            </IconButton>
                                                            <IconButton onClick={() => controller.handleOpenDeleteSubCategoryDialog(item?.id)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Box> */}
                                                    </Box>
                                                ))}
                                                <Box mt={1} ml={isSmallScreen ? -0.5 : -1}>
                                                    {/* <Button onClick={controller.handleOpenSubCategoryForm} sx={{ textTransform: 'none', color: TEXT_LIGHT_COLOR }}>
                                                        Add more
                                                        &nbsp;
                                                        <AddIcon sx={{ width: 15, height: 15 }} />
                                                    </Button> */}
                                                </Box>

                                            </Box>
                                    }

                                </Grid>
                            }
                        </Grid>
                        <FormDivision
                            merchantId={merchantId}
                            onClose={controller.handleCloseDivisionForm}
                            onRefetchData={controller.handleGetDataDivision}
                            dataMasterDivision={controller.dataMasterDivision}
                            openForm={controller.openDivisionForm}
                            mainGroupId={mainGroupData?.id}
                        />
                        <ConfirmDialog
                            open={controller.selectedDeleteDivisionId ? true : false}
                            title={`Do you want to delete division data?`}
                            loading={controller.loadingDeleteDivision}
                            onCancel={controller.handleCloseDeleteDivisionDialog}
                            onConfirm={controller.handleDeleteDivision}
                        />
                        <FormCategory
                            merchantId={merchantId}
                            onClose={controller.handleCloseCategoryForm}
                            onRefetchData={controller.handleRefetchCategory}
                            dataMasterCategory={controller.dataMasterCategory}
                            openForm={controller.openCategoryForm}
                            divisionId={controller.selectedDivision?.id}
                        />
                        <ConfirmDialog
                            open={controller.selectedDeleteCategoryId ? true : false}
                            title={`Do you want to delete category data?`}
                            loading={controller.loadingDeleteCategory}
                            onCancel={controller.handleCloseDeleteCategoryDialog}
                            onConfirm={controller.handleDeleteCategory}
                        />
                        <FormSubCategory
                            merchantId={merchantId}
                            onClose={controller.handleCloseSubCategoryForm}
                            onRefetchData={controller.handleRefetchSubCategory}
                            dataMasterSubCategory={controller.dataMasterSubCategory}
                            openForm={controller.openSubCategoryForm}
                            categoryId={controller.selectedCategory?.id}
                        />
                        <ConfirmDialog
                            open={controller.selectedDeleteSubCategoryId ? true : false}
                            title={`Do you want to delete sub category data?`}
                            loading={controller.loadingDeleteSubCategory}
                            onCancel={controller.handleCloseDeleteSubCategoryDialog}
                            onConfirm={controller.handleDeleteSubCategory}
                        />
                        {
                            controller.dataFormView
                            &&
                            <ViewDataForm onClose={controller.handleCloseDataFormView} title={controller.dataFormView.title} code={controller.dataFormView.code} nameEn={controller.dataFormView.nameEn} nameLa={controller.dataFormView.nameLa} imageUrl={controller.dataFormView.imageUrl} />
                        }
                    </Box>
                </>
                :
                <LinearProgress />
        }
    </Box>
}
export default MainGroup;